<button
  type="button"
  class="action-btn action-btn-edit cursor-pointer"
  [class.action-btn--sm]="size === 'sm'"
  [class.action-btn--lg]="size === 'lg'"
  [ngClass]="customClass"
  [disabled]="disabled"
  [title]="title"
  (click)="handleClick($event)"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    <path d="m15 5 4 4" />
  </svg>
</button>
